import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from '../../utils/apiService';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-md">
      <div className="container mx-auto px-6 py-3 flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/app/dashboard" className="text-2xl font-bold hover:text-blue-200 transition duration-300">DynPro Alumni</Link>
        </div>
        
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-6">
          <Link to="/app/dashboard" className="px-3 py-2 hover:text-blue-200 transition duration-300 font-medium">Dashboard</Link>
          <Link to="/app/alumni" className="px-3 py-2 hover:text-blue-200 transition duration-300 font-medium">Alumni List</Link>
          <Link to="/app/campaigns" className="px-3 py-2 hover:text-blue-200 transition duration-300 font-medium">Campaigns</Link>
          <Link to="/app/analytics" className="px-3 py-2 hover:text-blue-200 transition duration-300 font-medium">Analytics</Link>
          <Link to="/app/settings" className="px-3 py-2 hover:text-blue-200 transition duration-300 font-medium">Settings</Link>
          <button 
            onClick={handleLogout}
            className="bg-white text-blue-700 px-4 py-2 rounded-lg font-medium hover:bg-blue-50 transition duration-300 ml-2"
          >
            Sign Out
          </button>
        </div>
        
        {/* Mobile menu button */}
        <div className="md:hidden flex items-center">
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-white focus:outline-none"
          >
            <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path 
                  fillRule="evenodd" 
                  clipRule="evenodd" 
                  d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                />
              ) : (
                <path 
                  fillRule="evenodd" 
                  d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
                />
              )}
            </svg>
          </button>
        </div>
      </div>
      
      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-blue-700 bg-opacity-95">
          <div className="container mx-auto px-6 py-4">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/app/dashboard" 
                className="text-white hover:text-blue-200 transition duration-300"
                onClick={() => setIsMenuOpen(false)}
              >
                Dashboard
              </Link>
              <Link 
                to="/app/alumni" 
                className="text-white hover:text-blue-200 transition duration-300"
                onClick={() => setIsMenuOpen(false)}
              >
                Alumni List
              </Link>
              <Link 
                to="/app/campaigns" 
                className="text-white hover:text-blue-200 transition duration-300"
                onClick={() => setIsMenuOpen(false)}
              >
                Campaigns
              </Link>
              <Link 
                to="/app/analytics" 
                className="text-white hover:text-blue-200 transition duration-300"
                onClick={() => setIsMenuOpen(false)}
              >
                Analytics
              </Link>
              <Link 
                to="/app/settings" 
                className="text-white hover:text-blue-200 transition duration-300"
                onClick={() => setIsMenuOpen(false)}
              >
                Settings
              </Link>
              <button 
                onClick={() => {
                  handleLogout();
                  setIsMenuOpen(false);
                }}
                className="bg-white text-blue-700 px-4 py-2 rounded-lg font-medium hover:bg-blue-50 transition duration-300 inline-block text-center"
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
